<template>
  <div class="user-detail-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="info-box left-box">
          <div class="title">用户基本信息：</div>
          <div class="info">
            <div class="img-box">
              <div>
                <el-image
                  class="img"
                  :src="userDetail.avatar"
                  fit="cover"
                ></el-image>
              </div>
            </div>
            <div class="des">
              <div class="item" style="margin-right: 10px">
                <p>系统：{{ systemMap[userDetail.sys] }}</p>
                <p>用户ID：{{ userDetail.uid }}</p>
                <p>用户昵称：{{ userDetail.nickname }}</p>
                <p>
                  电话：{{ userDetail.phone }}
                  <span class="btn" @click="addPhoneModal">修改</span>
                </p>
                <p>会员身份：{{ userDetail.sumRole }}</p>
                <p>注册时间：{{ userDetail.created | dateFormat }}</p>

                <!-- <p>
                  糖果：{{ userDetail.candy }}
                  <span class="btn" @click="deductionTgModal">扣除</span>
                </p> -->
              </div>
              <div class="item">
                <!-- <p>冻结余额/元：{{ userDetail.balanceSum }}</p> -->
                <p>总佣金/元：{{ userDetail.sumBalance }}</p>
                <p>
                  可提现佣金/元：{{ userDetail.balance }}
                  <span class="btn" @click="addBalanceModal">修改</span>
                </p>
                <p>待提现佣金：{{ userDetail.freezeBalance }}</p>
                <p>总业绩奖励/元：{{ userDetail.sumGold }}</p>
                <p>业绩奖励余额/元：{{ userDetail.gold }}</p>
                <p>
                  现有积分：{{ userDetail.integral }}
                  <span class="btn" @click="addIntegralModal">修改</span>
                </p>
                <p>冻结中积分：{{ userDetail.freezeIntegral }}</p>
              </div>
              <div class="item">
                <p>团队总业绩：{{ userDetail.teamKpi }}</p>
                <p>我的好友人数：{{ userDetail.friend }}</p>
                <p>我的用户人数：{{ userDetail.teamPerson }}</p>
                <p>品牌方总利润：{{ userDetail.brandProfit }}</p>
                <p>可提现利润金额：{{ userDetail.brandDrawBalance }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="info-box superior" style="margin-left: 1px">
          <div class="superior-item" style="margin-left: 12px">
            <div class="title">上一级用户信息</div>
            <div class="info">
              <div class="des">
                <div class="item">
                  <p>
                    用户ID：{{ oneSuperior.uid
                    }}<span class="btn" @click="updateSuperiorModal">修改</span>
                  </p>
                  <p>用户姓名：{{ oneSuperior.nickname }}</p>
                  <p>手机号：{{ oneSuperior.phone }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="superior-item">
            <!-- <div class="title">上二级用户信息</div>
            <div class="info">
              <div class="des">
                <div class="item">
                  <p>用户ID：{{ twoSuperior.uid }}</p>
                  <p>用户姓名：{{ twoSuperior.nickname }}</p>
                  <p>手机号：{{ twoSuperior.phone }}</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="修改积分"
      :visible.sync="hzVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="hzForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="修改方式:">
          <el-radio v-model="hzForm.way" :label="1">添加</el-radio>
          <el-radio v-model="hzForm.way" :label="2">扣除</el-radio>
          <!-- <el-radio v-model="hzForm.way" :label="3">锁仓</el-radio>
          <el-radio v-model="hzForm.way" :label="4">锁仓释放</el-radio> -->
        </el-form-item>
        <el-form-item label="输入额度:" prop="company">
          <input
            class="form-input"
            placeholder="请输入积分"
            onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
            v-model.number="hzForm.number"
          />
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <textarea
            class="form-input"
            style="height: auto;"
            v-model="hzForm.remark"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea>
        </el-form-item>
        <!-- <el-form-item label="" prop="">
          <el-checkbox
            v-model="balanceForm.isRepurchase"
            :true-label="1"
            :false-label="2"
            >锁仓释放</el-checkbox
          >
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="hzVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addIntegral"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改悦贝"
      :visible.sync="hqVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="hqForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="修改方式:">
          <el-radio v-model="hqForm.way" :label="1">添加</el-radio>
          <el-radio v-model="hqForm.way" :label="2">扣除</el-radio>
          <el-radio v-model="hqForm.way" :label="3">锁仓</el-radio>
          <el-radio v-model="hqForm.way" :label="4">锁仓释放</el-radio>
        </el-form-item>
        <el-form-item label="输入额度:" prop="company">
          <input
            class="form-input"
            placeholder="请输入悦贝"
            onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
            v-model.number="hqForm.number"
          />
        </el-form-item>
        <el-form-item label="备注:" prop="describe">
          <input
            class="form-input"
            placeholder="请输入描述"
            v-model="hqForm.describe"
          />
        </el-form-item>
        <!-- <el-form-item label="" prop="">
          <el-checkbox
            v-model="balanceForm.isRepurchase"
            :true-label="1"
            :false-label="2"
            >锁仓释放</el-checkbox
          >
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="hqVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addHq"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改余额"
      :visible.sync="balanceVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="balanceForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="修改方式:">
          <el-radio v-model="balanceForm.way" :label="1">添加</el-radio>
          <el-radio v-model="balanceForm.way" :label="2">扣除</el-radio>
          <!-- <el-radio v-model="balanceForm.way" :label="3">锁仓</el-radio>
          <el-radio v-model="balanceForm.way" :label="4">锁仓释放</el-radio> -->
        </el-form-item>
        <el-form-item label="输入额度:" prop="company">
          <input
            class="form-input"
            placeholder="请输入余额"
            onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
            v-model.number="balanceForm.number"
          />
        </el-form-item>
        <el-form-item label="备注:" prop="remark">
          <textarea
            class="form-input"
            style="height: auto;"
            v-model="balanceForm.remark"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea>
        </el-form-item>
        <!-- <el-form-item label="" prop="">
          <el-checkbox
            v-model="balanceForm.isRepurchase"
            :true-label="1"
            :false-label="2"
            >锁仓释放</el-checkbox
          >
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="balanceVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addBalance"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改手机号"
      :visible.sync="phoneVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="phoneForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="手机号" prop="company">
          <input
            class="form-input"
            placeholder="请输入手机号"
            v-model="phoneForm.phone"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="phoneVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="addPhone"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="扣除糖果"
      :visible.sync="deductionTgVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="tgForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="扣除糖果" prop="company">
          <!-- <input
            class="form-input"
            placeholder="请输入扣除数额"
            v-model="tgForm.number"
          /> -->
          <input
            type="text"
            class="form-input"
            v-model.number="tgForm.number"
            onkeypress="/([0-9]|\.)/.test(event.key)"
            oninput="value = /^\d+(\.{1}\d{0,2})?/g.exec(value) ? /^\d+(\.{1}\d{0,2})?/g.exec(value)[0] : ''"
            placeholder="请输入扣除数额"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="deductionTgVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="deductionTg"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="社区数据查看"
      :visible.sync="kpiVisible"
      width="546px"
      class="dialog"
    >
      <div class="api-dialog">
        <div class="item">社区总积分：{{ kpiInfo.totalIntegral }}</div>
        <div class="item">社区已释放积分：{{ kpiInfo.releaseIntegralSum }}</div>
        <div class="item">社区冻结中积分：{{ kpiInfo.freezeIntegralSum }}</div>
        <div class="item">总悦贝：{{ kpiInfo.goldSum }}</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="kpiVisible = false"
        >
          确 定
        </button>
      </div>
    </el-dialog>
    <el-dialog
      title="修改上级"
      :visible.sync="updateSuperiorVisible"
      width="460px"
      class="dialog"
    >
      <el-form
        ref="form"
        v-model="superiorForm"
        class="add-hz-form"
        label-width="80px"
      >
        <el-form-item label="用户ID" prop="company">
          <input
            class="form-input"
            placeholder="请输入用户ID"
            v-model.number="superiorForm.superior"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button
          class="cancel-btn"
          style="height: 32px; width: 60px"
          @click="updateSuperiorVisible = false"
        >
          取 消
        </button>
        <button
          class="confirm-btn"
          style="height: 32px; width: 60px"
          @click="updateSuperior"
        >
          确 定
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import dayjs from 'dayjs';
import Header from '@/components/common/header';
import { levelMap } from '@/config.js';
export default {
  components: {
    Header
  },
  name: 'user-detail',
  data() {
    return {
      loading: 0, // 加载中
      labelWidth: '200px',
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '用户详情'
      },
      uid: null,
      userDetail: {},
      oneSuperior: {},
      twoSuperior: {},
      earnings: {},
      hzVisible: false,
      hzForm: {
        number: null,
        way: 1,
        remark: ''
      },
      hqVisible: false,
      hqForm: {
        number: null,
        way: 1,
        describe: ''
      },
      balanceVisible: false,
      balanceForm: {
        number: null,
        way: 1,
        remark: ''
      },
      superiorForm: {
        superior: null
      },
      phoneVisible: false,
      phoneForm: {
        phone: ''
      },
      kpiVisible: false,
      deductionTgVisible: false,
      tgForm: {
        number: null
      },
      roleMap: {},
      levelMap: levelMap,
      kpiInfo: {},

      system: [],
      systemMap: {},
      updateSuperiorVisible: false
    };
  },
  filters: {
    // 时间格式化
    dateFormat(date) {
      if (!date) return '请选择时间';
      let day = dayjs(date);
      return day.format('YYYY-MM-DD HH:mm:ss');
    }
  },
  mounted() {
    // 获取用户详情
    let query = this.$route.query;
    this.getDictionary();
    if (query.uid) {
      this.uid = +query.uid;
      this.getUserDetail();
    }
  },
  computed: {},
  methods: {
    // 获取用户详情
    getUserDetail() {
      this.loading++;
      this.httpGet(this.$root.userDetail, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.userDetail = res.userInfo;
          this.oneSuperior = res.oneSuperior;
          this.twoSuperior = res.twoSuperior;
          this.earnings = {};
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getDictionary(){
      // this.getDictionaryByName('role');
      this.getDictionaryByName('system');
    },
    getDictionaryByName(dataName){
      this.loading++;
      this.httpGet(this.$root.getDictionaryByName, {
        dataName
      }).then(
        (res) => {
          this.loading--;
          this[dataName] = res.list;
          let obj = {};
          res.list.forEach(item => {
            obj[item.value] = item.labelName;
          });
          this[dataName + 'Map'] = obj;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getGroupSum() {
      this.loading++;
      this.httpGet(this.$root.getGroupSum, {
        uid: this.uid
      }).then(
        (res) => {
          this.loading--;
          this.kpiInfo = res;
          this.kpiVisible = true;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    // 添加积分
    addIntegralModal() {
      this.hzForm = { number: null, way: 1, remark: '' };
      this.hzVisible = true;
    },
    // 添加悦贝
    addHqModal() {
      this.hqForm = { number: null, way: 1, describe: '' };
      this.hqVisible = true;
    },
    addPhoneModal() {
      this.phoneForm = { phone: '' };
      this.phoneVisible = true;
    },
    addBalanceModal() {
      this.balanceForm = { number: null, way: 1, remark: '' };
      this.balanceVisible = true;
    },
    kpiModal() {
      this.getGroupSum();
    },
    updateSuperiorModal(){
      this.updateSuperiorVisible = true;
    },
    updateSuperior(){
      if (!this.superiorForm.superior) {
        this.$message.error('请输入上级ID');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateSuperior, {
        ...this.superiorForm,
        uid: this.uid
      }).then(
        (res) => {
          this.updateSuperiorVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    deductionTgModal() {
      this.deductionTgVisible = true;
    },
    deductionTg() {
      if (!this.tgForm.number) {
        this.$message.error('请输入扣除糖果');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateTg, {
        uid: +this.uid,
        ...this.tgForm,
        way: 2
      }).then(
        (res) => {
          this.deductionTgVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    addIntegral() {
      if (!this.hzForm.number) {
        this.$message.error('请输入积分');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateIntegral, {
        uid: +this.uid,
        ...this.hzForm
      }).then(
        (res) => {
          this.hzVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    addHq() {
      if (!this.hqForm.number) {
        this.$message.error('请输入悦贝');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateHq, {
        uid: +this.uid,
        ...this.hqForm
      }).then(
        (res) => {
          this.hqVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    addBalance() {
      if (!this.balanceForm.number) {
        this.$message.error('请输入余额');
        return;
      }
      this.loading++;
      this.httpPut(this.$root.updateBalance, {
        uid: +this.uid,
        ...this.balanceForm
      }).then(
        (res) => {
          this.balanceVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    },
    addPhone() {
      this.loading++;
      this.httpPut(this.$root.updatePhone, {
        uid: +this.uid,
        ...this.phoneForm
      }).then(
        (res) => {
          this.phoneVisible = false;
          this.$message.success('操作成功');
          this.loading--;
          this.getUserDetail();
        },
        (err) => {
          this.$message.error(err);
          this.loading--;
        }
      );
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.user-detail-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 24px;

    // content 表格
    .content {
      width: 100%;
      font-size: 14px;
      box-sizing: border-box;
      border-radius: 2px;
      flex-y(flex-start, flex-start);

      .info-box {
        flex: 1;
        flex-y(flex-start, flex-start);
        padding: 32px;
        background: white;
        box-sizing: border-box;
        height: 100%;
        width: 100%;
        margin-bottom: 12px;

        .title {
          font-size: 18px;
          color: gray3;
          // width: 225px;
          // min-width: 225px;
          font-weight: bold;
        }

        .img-box {
          flex-y(center, flex-start);
          width: 24%;
          min-width: 160px;
          white-space: nowrap;
          word(14px, gray3);

          >div {
            flex-y(center, center);
          }

          .img {
            width: 120px;
            min-width: 120px;
            height: 120px;
            min-height: 120px;
            border-radius: 60px;
            margin-bottom: 8px;
          }
        }

        .info {
          width: 100%;
          flex-x(flex-start);
          padding-top: 48px;
          box-sizing: border-box;

          .des {
            width: 100%;
            flex-x(space-between, flex-start);
            flex-wrap: wrap;
            flex: 1;

            .item {
              min-width: 200px;
              width: 25%;
              flex: 1;
              flex-wrap: wrap;

              p {
                font-size: 14px;
                line-height: 36px;

                // white-space: nowrap;
                .btn {
                  width: auto;
                  line-height: 24px;
                  border-radius: 12px;
                  display: inline-block;
                  padding: 0 12px;
                  background: #E33C64;
                  margin-right: 8px;
                }
              }

              .btn {
                width: 72px;
                height: 22px;
                background: #DA593E;
                font-size: 12px;
                line-height: 22px;
                text-align: center;
                margin-left: 15px;
                color: #fff;
                border-radius: 4px;
                cursor: pointer;
              }
            }
          }
        }
      }

      .superior {
        flex-x(flex-start, flex-start);
        flex: 0.8;

        .superior-item {
          // flex: 1;
          flex-y(flex-start, flex-start);

          .info {
            width: auto;
            margin-left: 180px;
          }

          .item {
            min-width: auto !important;
          }
        }
      }
    }
  }

  .add-hz-form {
    padding-top: 15px;

    .form-input {
      width: 300px;
      height: 32px;
      margin-left: 3px;
      margin-right: 16px;
      border-radius: 5px;
      padding: 0 12px;
      border: 1px solid #ccc;
      box-sizing: border-box;
      word(13px, #333);
    }
  }

  .api-dialog {
    padding: 0 60px;
    box-sizing: border-box;

    .item {
      line-height: 60px;
    }
  }
}
</style>
